import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import { useState } from 'react';
import { Modal } from './Modal';

interface Props {
  open: boolean;
  email: string;
  temporaryPassword: string;
  onClose: () => void;
}

export function ResetPasswordDialog({ open, email, temporaryPassword, onClose }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(temporaryPassword);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="임시 비밀번호 발급됨"
      description={`${email} 계정의 비밀번호가 초기화되었습니다. 이 화면을 닫으면 다시 확인할 수 없습니다.`}
      size="md"
    >
      <div className="space-y-4">
        <div className="flex items-center gap-2 rounded-md border border-border bg-surface-muted px-3 py-2.5">
          <code className="font-mono text-sm flex-1 break-all">{temporaryPassword}</code>
          <button
            type="button"
            onClick={copy}
            aria-label="비밀번호 복사"
            className="text-foreground-muted hover:text-foreground"
          >
            <Copy className="size-4" />
          </button>
        </div>
        {copied ? <p className="text-xs text-foreground-muted">복사되었습니다.</p> : null}
        <div className="flex justify-end">
          <Button type="button" onClick={onClose}>
            확인
          </Button>
        </div>
      </div>
    </Modal>
  );
}
